import type { SignableAttachment } from '../office/outlook';
import './MainPanel.css';

export type PdfStatusMessage = {
  text: string;
  oneDriveUrl?: string | null;
  oneDriveLabel?: string;
};

type Props = {
  attachments: SignableAttachment[];
  busyId: string | null;
  message: PdfStatusMessage | null;
  error: string | null;
  onSign: (att: SignableAttachment) => void;
};

export function AttachmentsPanel({ attachments, busyId, message, error, onSign }: Props) {
  return (
    <div className="mp-section">
      <h2 className="mp-h2">Dokumente</h2>
      <p className="mp-muted">PDF und Word (.docx)</p>

      {attachments.length === 0 ? (
        <p className="mp-muted">Keine PDF- oder DOCX-Anhänge in dieser E-Mail.</p>
      ) : (
        <ul className="mp-att-list">
          {attachments.map((att) => (
            <li key={att.id} className="mp-att-row">
              <div className="mp-att-name">
                <span className="mp-att-kind">{att.kind === 'docx' ? 'DOCX' : 'PDF'}</span>{' '}
                {att.name}
              </div>
              <button
                type="button"
                className="sp-btn sp-btn--primary"
                disabled={busyId !== null}
                onClick={() => onSign(att)}
              >
                {busyId === att.id ? 'Laden…' : 'Signieren'}
              </button>
            </li>
          ))}
        </ul>
      )}

      {message ? (
        <div className="sp-success">
          <p className="sp-success-text">{message.text}</p>
          {message.oneDriveUrl ? (
            <p className="sp-success-link">
              <a href={message.oneDriveUrl} target="_blank" rel="noopener noreferrer">
                {message.oneDriveLabel || 'In OneDrive öffnen'}
              </a>
            </p>
          ) : null}
        </div>
      ) : null}
      {error ? (
        <div className="sp-error" role="alert">
          <p>{error}</p>
        </div>
      ) : null}
    </div>
  );
}
